import React from "react";
import * as style from "../styles.module.scss";
import OnboardImage from "../../OnboardImage";

const LegalComplianceStep = ({
  component,
  title,
  description,
  imagePath,
  imageClass,
  currentStep,
  totalSteps,
  currentJobProgressState,
}) => {
  return (
    <div className="row h-100">
      <OnboardImage
        title={title}
        desktopDescription={description}
        mobileDescription={description}
        imagePath={imagePath}
        className={style.imageBackground}
        imageClassName={style[imageClass]}
        innerProgressTitle="Legal compliance"
        innerProgressCurrentStep={currentStep}
        innerProgressTotalSteps={totalSteps}
        innerProgressShow
        currentJobProgressState={currentJobProgressState}
      />
      {component}
    </div>
  );
};

export default LegalComplianceStep;
